import React from 'react';
import PropTypes from 'prop-types';

const BoutonIcon = ({icon, onClick, transparent = false, width = 4, height = 4}) => {
    return (
        <button onClick={onClick}
                className={`p-2 ${transparent ? 'bg-transparent hover:scale-125' : 'bg-[#181818] hover:bg-[#272727]'} transition-all duration-200 rounded-md flex items-center justify-center`}>
            <div style={{ width: `${width * 0.25}rem`, height: `${height * 0.25}rem` }}>
                {icon}
            </div>
        </button>
    )
}

BoutonIcon.propTypes = {
    icon: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    transparent: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default BoutonIcon;